// import React from "react";
// import { Result, Button } from "antd";
// import { WarningOutlined } from "@ant-design/icons";

// const PermissionDenied = () => {
//   return (
//     <div
//       style={{
//         height: "100vh",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       <Result
//         icon={<WarningOutlined style={{ color: "#faad14" }} />}
//         status="403"
//         title="Access Denied"
//         subTitle={
//           <>
//             <div>you do not have permission to access this page.</div>
//           </>
//         }
//       />
//     </div>
//   );
// };

// export default PermissionDenied;

import React from "react";
import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { dentalIcons } from "../utils-icons/dentalIcons";
import CustomDefaultButton from "../components/d-reusable/CustomDefaultButton";
import CustomPrimaryButton from "../components/d-reusable/CustomPrimaryButton";

const PermissionDenied = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        height: "80vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f8f9fb",
      }}
    >
      <Result
        icon={
          <img
            src={dentalIcons.accessDenied} // Add this to your icons
            alt="Permission Denied"
            style={{ width: 400, objectFit: "contain" }}
          />
        }
        title="Permission Denied"
        subTitle={
          <div style={{ fontSize: 14, color: "#666" }}>
            You do not have permission to access this section of Dental ID.
            <br />
            Please contact your administrator if you believe this is a mistake.
          </div>
        }
        extra={
          <CustomPrimaryButton title="Go Back" onClick={() => navigate(-1)} />
        }
      />
    </div>
  );
};

export default PermissionDenied;
